<template>
    <div>
        <base-question :text="`Pagante ${index + 1}`" class="payer"/>

        <span v-if="multiplePayers" class="delete-payer" @click="removePayer(index)">
            <i class="fal fa-times"></i>
        </span>

        <base-tabs :tab-actived="tabActive" @change="switchTabs($event, index)" :tabs="paymentTabs" class="payment-tabs" />
        <base-radio v-model="payer.method" :option="method.alias" v-for="(method, idx) in (paymentTabs[tabActive] && paymentTabs[tabActive].methods ? paymentTabs[tabActive].methods : [])" :key="idx" :label="methodName(method.alias)" :family="`payment${index}`" class="mt_10"/>

        <div>
            <div class="mt_20 mb_30" />
            <base-input v-model="payer.amount" label="Valor" :disabled="!multiplePayers || equalDivision" :money-mask="StringLanguage.currencyConfigs" :class="tabActive === 3 ? '' : 'mb_5'" />

            <div v-if="paymentMethod === money">
            <!-- <div v-if="tabActive === 3"> -->
                <base-checkbox label="Cliente precisa de troco" v-model="haveChange" class="mt_25" :checked="haveChange" />

                <div v-if="haveChange" class="mt_25">
                    <div class="mt_20 mb_30" />
                    <base-input :max="10" label="Troco para" v-model="changeFor" :money-mask="StringLanguage.currencyConfigs" :class="'mb_5'" />
                    <p v-if="+changeFor > +payer.amount" class="change-value">Valor do troco: <span>{{ Utils.convertMoney(changeFor - payer.amount) }}</span></p>
                </div>
            </div>
        </div>
	</div>
</template>

<script>
import BaseCard from '@/components/Card';
import BaseQuestion from '@/components/Question';
import BaseTabs from '@/components/Tabs';
import BaseRadio from '@/components/Radio';
import BaseInput from '@/components/Input';
import BaseAdd from '@/components/Add';
import BaseCheckbox from '@/components/Checkbox';

import { PaymentMethod, Method, Status } from 'easyjs/lib/Schema/Payment';

import Utils from '@/utils';

export default {
    data() {
        return {
            Utils,
            tabActive: 0,
            equalDivision: true,
			haveChange: this.payer.hasChange || false,
			changeFor: 0,
			paymentMethod: 0,
			money: PaymentMethod.FISICO | PaymentMethod.MONEY,
        }
    },
    props: {
        paymentTabs: {},
        index: {
            type: Number,
            required: true,
        },
		tabIndex: {
			required: true
		},
		multiplePayers: {
			type: Boolean,
			required: true
		},
        payer: {}
	},
	created() {
		this.paymentMethod = (this.paymentTabs[this.tabActive].methods.length > 0) ? this.paymentTabs[this.tabActive].type : null;
	},
    components: {
        BaseCard,
        BaseQuestion,
        BaseTabs,
        BaseRadio,
        BaseInput,
        BaseAdd,
        BaseCheckbox,
    },
    methods: {
        removePayer (index) {
			this.$emit('removePayer', index);
        },
        changeAmount (index) {
            const count = this.order.payment.payers.length;
            const totalPayers = this.order.payment.payers.reduce((acumulator, current) => {return acumulator + current});

			if (index + 1 < count) {
                this.order.payment.payers[index+1].amount = this.total - this.order.payment.payers[index].amount;
            } else if (index + 1 == count) {
                this.order.payment.payers[index].amount = this.total;
			}

            this.recalculePayer();
        },
        methodName(value) {
			let { alias, type, name } = Method[value];

			if (type == 20) {
				const methodType = {
					'ALIMENTACAO': 'Alimentação',
					'REFEICAO': 'Refeição'
				};

				const methodTypeSplit = alias.split('_');
				const type = methodTypeSplit[methodTypeSplit.length - 1];

				name = `${name} (${methodType[type]})`;
			}

			return name;
        },
        switchTabs (value, index) {
            this.paymentTabs.forEach((item, i) => {
                if (item.value == value) {
                    this.payer.paymentMethod = this.paymentMethod = item.type;
                    this.tabActive = i;

                    if (item.methods[0]) {
                        this.payer.method = item.methods[0].alias;
                    }

					this.$emit('setPayerMethod', index, item, i);
                }
            });

            this.$forceUpdate();
		},
		setChangeFor() {
			this.$emit('setChangeFor', this.index, parseFloat(this.changeFor), this.haveChange);
		}
    },
    watch: {
        tabIndex:{
            immediate: true,
            handler(newValue) {
                this.tabActive = this.tabIndex || 0;
            }
        },
        haveChange: function() {
            if(!this.haveChange) {
				this.changeFor = 0;
			}

			this.setChangeFor();
		},
		changeFor: function() {
			const parsedChangeFor = parseFloat(this.changeFor);

			if (parsedChangeFor > 0) {
				this.$emit('setChangeFor', this.index, parsedChangeFor, this.haveChange);
			}
		}
	}
}
</script>

<style>
    .delete-payer{
        position: absolute;
        top: 26px;
        right: 0;
        font-size: 1.4em;
        color: #AAAAAB;
        cursor: pointer;
        padding: 5px;
    }
    .question-payer{
        margin-bottom: 20px;
    }
    .change-value{
        font-size: 1.2em;
        padding: 15px 20px;
        background: var(--box-up);
        border-radius: 5px;
        color: #999;
        margin-top: 20px;
    }
    .change-value span{
        font-weight: 600;
    }
</style>